if (!customElements.get("gtc-check")) {
  class GtcCheck extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector("input[type=checkbox]");
      this.cartButton = document.querySelectorAll("button[name=checkout]");
      this.hasBankIdToken = false;

      this.toggleCartButton(true);

      if (this.checkbox) {
        this.checkbox.addEventListener("click", this.gtcCheckEvent.bind(this));
      }

      this.loadBankIdToken();
    }

    gtcCheckEvent(e) {
      this.updateDisabledState();
    }

    toggleCartButton(flag) {
      this.cartButton.forEach((el) => (el.disabled = flag));
    }

    updateDisabledState() {
      const isChecked = !!(this.checkbox && this.checkbox.checked);
      const disabled = !(isChecked && !this.tokenExpired);
      this.toggleCartButton(disabled);
    }

    async loadBankIdToken() {
      try {
        await fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then((resp) => (resp.ok ? resp.json() : null))
          .then(async (cart) => {
            const attrs = cart && cart.attributes;
            const jwttoken = attrs.bankid_authorization_token;
            this.tokenExpired = this.isTokenExpired(jwttoken);
            if (this.tokenExpired) {
              await this.removeBankIdToken(cart);
            }
            this.updateDisabledState();
          })
          .catch(() => {});
      } catch (e) {
        /* noop */
      }
    }
    decodePayload(token) {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      return JSON.parse(atob(base64));
    }
    isTokenExpired(token, skewSeconds = 30) {
      const { exp } = this.decodePayload(token) || {};
      if (!exp) return true;
      const nowSec = Math.floor(Date.now() / 1000);
      return nowSec >= exp - skewSeconds;
    }

    async removeBankIdToken(cart) {
      const cartAttributes = (cart && cart.attributes) || {};
      const nextAttributes = {
        ...cartAttributes,
        bankid_authorization_token: "",
      };
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ attributes: nextAttributes }),
      })
        .then(() => {
          localStorage.removeItem("bankid_auth_session_id");
        })
        .finally(() => {
          window.location.reload();
        });
    }
  }
  customElements.define("gtc-check", GtcCheck);
}
